﻿import React, { useContext, useEffect } from 'react';
import Context, { context_type } from '@Util/Context';
import { str_isEmpty } from '@Util/Utils';
import { Icon_Close } from '@Elements/ImageElements/Icons';

export default function Status_Update(): JSX.Element {
    const {
        status_update,
        set_status_update
    }: context_type = useContext(Context);

    useEffect(() => {
        if (status_update.visible && !str_isEmpty(status_update.text)) {
            setTimeout(function () {
                set_status_update((prevData) => {
                    return {
                        ...prevData,
                        visible: false
                    }
                });

                setTimeout(function () {
                    set_status_update((prevData) => {
                        return {
                            ...prevData,
                            text: "",
                            type: "Success"
                        }
                    });
                }, 1500);
            }, 3500);
        }
    }, [status_update.visible]);

    function create_element_class(): string {
        let class_str: string = "Status_Update";

        if (status_update.type === "Success") {
            class_str += " Status_Update--Success";
        }

        if (status_update.type === "Error") {
            class_str += " Status_Update--Error";
        }

        if (!str_isEmpty(status_update.text)) {
            class_str += " Status_Update--Visible";
        }

        return class_str;
    }

    return (
        <aside className={create_element_class()}>
            <p className="Normal">{status_update.text}</p>
            <button
                type="button"
                onClick={() => {
                    set_status_update({
                        visible: false,
                        text: "",
                        type: "Success"
                    });
                }}
            >
                <Icon_Close />
            </button>
        </aside>
    )
}